"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _comboBox = _interopRequireWildcard(require("../combo-box"));

var _dataGridContext = require("../../../data-grid-context");

var ComboBoxImplementation = function ComboBoxImplementation(_ref) {
  var label = _ref.label,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      defaultValue = _ref.defaultValue,
      _ref$dataSet = _ref.dataSet,
      dataSet = _ref$dataSet === void 0 ? [] : _ref$dataSet;

  var _useDataGridContext = (0, _dataGridContext.useDataGridContext)(),
      filters = _useDataGridContext.filters,
      setFilters = _useDataGridContext.setFilters;

  return /*#__PURE__*/_react["default"].createElement(_comboBox["default"], {
    onChange: setFilters,
    value: filters || options.find(function (f) {
      return f["default"];
    }) || defaultValue
  }, /*#__PURE__*/_react["default"].createElement(_comboBox.ComboBoxInput, {
    label: label
  }), /*#__PURE__*/_react["default"].createElement(_comboBox.ComboBoxDropDown, null, /*#__PURE__*/_react["default"].createElement(_comboBox.ComboBoxListWrapper, null, options.map(function (option) {
    return option.header ? /*#__PURE__*/_react["default"].createElement(_comboBox.ComboBoxListSubheader, {
      key: option.key,
      actionArea: option.actionArea
    }, option.key) : /*#__PURE__*/_react["default"].createElement(_comboBox.ComboBoxItem, {
      key: option.key,
      value: option,
      amount: option.records || option.query(dataSet).length
    }, option.key);
  }))));
};

ComboBoxImplementation.propTypes = {
  label: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].string]),
  dataSet: _propTypes["default"].array,
  options: _propTypes["default"].array.isRequired,
  defaultValue: _propTypes["default"].any
};
var _default = ComboBoxImplementation;
exports["default"] = _default;